<template>
	<q-page padding>
		<div class="q-display-1 text-secondary">
			<q-icon name="fas fa-list" class="q-mb-sm" /> {{ $t('library_categories') }}
		</div>

		<div class="row gutter-sm">
			<div class="col-xs-12 col-sm-12">
				<q-field :count="140">
					<q-input
						v-model="title"
						:float-label="$t('title')"
						:error="$v.title.$error"
						@input="$v.title.$touch"
					/>
				</q-field>
			</div>

			<div class="col-xs-6 col-sm-4">
				<p class="caption">{{ $t('highlight') }}</p>
				<q-btn-toggle
					v-model="featured"
					:toggle-color="getColorFeatured"
					:options="featureds"
				/>
			</div>

			<div class="col-xs-6 col-sm-4">
				<p class="caption">{{ $t('status') }}</p>
				<q-btn-toggle v-model="status" :toggle-color="getColorStatus" :options="statuses" />
			</div>

			<div class="col-xs-6 col-sm-4">
				<p class="caption">{{ $t('icon') }}</p>
				<q-btn :icon="selected_icon" color="tertiary" @click="show_icons = true" />
			</div>
		</div>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_library_categories' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<q-modal v-model="show_icons" :content-css="{ maxWidth: getMaxWidth, minHeight: '80vh' }">
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_icons = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('icon') }}
					</q-toolbar-title>
				</q-toolbar>

				<q-toolbar slot="header">
					<q-search
						class="full-width"
						inverted
						v-model="search"
						color="none"
						:debounce="500"
					/>
				</q-toolbar>

				<div class="layout-padding">
					<div
						class="category-icon-item"
						v-for="(icon, index) in iconList"
						:key="index"
						@click="selectIcon(icon)"
					>
						<q-icon :name="'fas fa-' + icon" />
					</div>
				</div>
			</q-modal-layout>
		</q-modal>
	</q-page>
</template>

<script>
import icons from 'assets/icons.json'
import { mapGetters } from 'vuex'
import { required, maxLength } from 'vuelidate/lib/validators'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'library', 'admin'] },

	data() {
		return {
			id_category: '',
			title: '',
			featured: 1,
			featureds: [
				{ label: this.$t('yes'), value: true },
				{ label: this.$t('no'), value: false },
			],
			status: 1,
			statuses: [
				{ label: this.$t('active_f'), value: 1 },
				{ label: this.$t('inactive_f'), value: 2 },
			],
			show_icons: false,
			selected_icon: 'fas fa-th',
			icons: [],
			search: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			id_user_client_selected: 'common/id_user_client_selected',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		iconList() {
			if (this.search) {
				return this.icons.filter((e) => {
					return e.includes(this.search)
				})
			} else return this.icons
		},

		getColorFeatured() {
			if (this.featured == 1) return 'positive'
			else return 'negative'
		},

		getColorStatus() {
			if (this.status == 1) return 'positive'
			else return 'negative'
		},

		getMaxWidth() {
			if (this.$q.platform.is.mobile) return '100vw'
			else return '80vw'
		},
	},

	methods: {
		fetchData() {
			this.$axios
				.get('/admin_library_files/categories/' + this.id_category + '/', this.getHeader)
				.then((response) => {
					this.title = response.data.title
					this.featured = response.data.is_featured
					this.status = response.data.status
					this.selected_icon = response.data.icon

					this.$q.loading.hide()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		saveData() {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('client', this.id_user_client_selected)
				fd.append('title', this.title)
				fd.append('status', this.status)
				fd.append('is_featured', this.featured)
				fd.append('icon', this.selected_icon)

				if (this.id_category != 0) {
					this.$axios
						.put(
							'/admin_library_files/categories/' + this.id_category + '/',
							fd,
							this.getHeader
						)
						.then((response) => {
							this.$q.loading.hide()
							this.$router.push({ name: 'admin_library_categories' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post('/admin_library_files/categories/', fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()
							this.$router.push({ name: 'admin_library_categories' })
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		selectIcon(icon) {
			this.selected_icon = 'fas fa-' + icon
			this.search = ''
			this.show_icons = false
		},

		getOrder(name) {
			if (name == 'cancel') {
				if (this.$q.platform.is.mobile) return 'order-last'
				else return 'order-first'
			} else if (name == 'save') {
				if (this.$q.platform.is.mobile) return 'order-first'
				else return 'order-last'
			}
		},
	},

	created() {
		icons[0].solid.forEach((icon) => {
			this.icons.push(icon)
		})

		this.id_category = this.$route.params.id
		if (this.id_category != 0) this.fetchData()
	},

	validations() {
		return {
			title: { required, maxLength: maxLength(140) },
		}
	},
}
</script>

<style lang="stylus" scoped>
.category-icon-item
    float left
    border 1px solid #EFEFEF
    display table
    width 3rem
    height 3rem
    &:hover
        border 1px solid #000000

.category-icon-item i
    margin 0 auto
    margin-top 0.5rem
    font-size 2rem
    text-align center
    vertical-align middle
    display table-cell
    cursor pointer
    color #444
</style>
